// eslint-disable-next-line import/prefer-default-export
export const DISCOUNT_BY_QUANTITY = 'by_quantity';
